<template>
  <div>
    <div class="container box">
      <router-view />
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: [],
  data() {
    return {};
  },
  computed: {},
  methods: {},
  mounted() {
    this.$store.dispatch("gebruikers/getGebruikers");
  },
};
</script>

<style scoped>
.centered-box {
  min-width: 800px;
}
</style>
